module.exports = __webpack_public_path__ + "static/media/search.e47d03c4.svg";